import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { EventEmitterService } from 'app/util/emitter-service/emitter-service';
import { EVENT_MSGS_UPDATE } from 'app/util/emitter-service/nome-evento';
import { bObservableUsuario, ObservableLotacao } from 'app/util/observable-util';
import { Message } from 'primeng/primeng';

import { environment } from '../../../environments/environment';
import { PadraoService } from '../../service/padrao.service';

@Component({
  selector: 'modulos-crud',
  templateUrl: 'modulos-crud.component.html',
  styleUrls: ['./modulos-crud.component.scss']
})
export class ModulosComponent implements OnInit, AfterContentChecked {

  contentCheck: number = 0;
  blockedPanel: boolean = true;
  sistemas: Array<any> = [];
  msgs: Message[] = [];
  count: number = 0;

  constructor(
    public service: PadraoService,
    private usuarioSessao: bObservableUsuario,
    private lotacaoService: ObservableLotacao) {

    if (localStorage.getItem('token') != null) {

      this.usuarioSessao.getValue.subscribe(data => {
        if (data) {
          let usuario = data.obj
          let listaLotacao = usuario.lotacaoDTO
          if (listaLotacao == undefined) {
            window.location.href = `${environment.apiEndpoint}/api/Autenticar/login`
          } else {
            //const uniqueSet: Array<any> = [];
            listaLotacao.find(x => x.id == localStorage.getItem('lotacao')).perfilDTO.forEach(e => {
              this.sistemas.push(e.sistemaDTO.id);
            });
            const uniqueSet = new Set(this.sistemas);
            this.sistemas = [];
            uniqueSet.forEach(element => {
              this.service.Obter('api/autenticar/obterSistemas', element).subscribe(obj => {
                if (obj) {
                  this.sistemas.push(obj);
                }
              });
            });
          }
        }
      })
    }
  }

  ngOnInit() {
    if (sessionStorage.getItem('msg') !== null) {
      this.showMsg('success', 'Mensagem de Sucesso', sessionStorage.getItem('msg'))
    }
    sessionStorage.removeItem('msg');
  }

  ngAfterContentChecked() {
    if (this.contentCheck++ > 10) {
      this.blockedPanel = false;
    }
  }

  showMsg(severity: string, summary: string, detail: string) {
    this.msgs = [];
    this.msgs.push({ severity: severity, summary: summary, detail: detail });
    EventEmitterService.get(EVENT_MSGS_UPDATE).emit(this.msgs);
  }
  clickSistem(link: string) {
    window.location.href = link
  }
}


// WEBPACK FOOTER //
// ./src/app/modulos/crud/modulos-crud.component.ts